import { FC } from "react";
import { Point } from "refsix-js-models";

interface ReplayPitchPositionProps {
    currentGPSPoint?: Point;
    playing: boolean;
}

/**
 * Top layer showing the official's current position on the pitch as a moving
 * dot, kept in sync with video playback. Ported from the legacy
 * PitchPositionDirective.
 */
const ReplayPitchPosition: FC<ReplayPitchPositionProps> = ({
    currentGPSPoint,
    playing,
}) => {
    const hasPoint =
        currentGPSPoint?.x != null && currentGPSPoint?.y != null;

    return (
        <div className="replay-layer replay-dot-layer">
            <div
                className={"point" + (playing ? " playing" : "")}
                style={{
                    top: currentGPSPoint?.y ?? 0,
                    left: currentGPSPoint?.x ?? 0,
                    visibility: hasPoint ? "visible" : "hidden",
                }}
            />
        </div>
    );
};

export default ReplayPitchPosition;
